/**
 * Extracts offer id from a deep link or accept URL.
 * Only the `tradeOfferID` query parameter is supported (the shape produced by bts-ui-backend).
 */
export function extractOfferIdFromAcceptUrl(
  url: string | undefined,
): string | undefined {
  if (!url || typeof url !== 'string') {
    return undefined;
  }

  try {
    let parsed: URL;

    if (typeof window !== 'undefined') {
      parsed = new URL(url, window.location.origin);
    } else {
      // Non-browser (SSR/tests): only absolute URLs can be parsed; relative URLs have no base.
      if (!/^https?:\/\//i.test(url.trim())) {
        return undefined;
      }

      parsed = new URL(url);
    }

    const tradeOfferId = parsed.searchParams.get('tradeOfferID');

    if (tradeOfferId?.trim()) {
      return tradeOfferId.trim();
    }

    return undefined;
  } catch {
    return undefined;
  }
}
